import * as z from "zod";
import { InsertionPosition } from "./insertion-position";
import { WidgetElementType } from "./widget-config";

export const coveragePlacementSchema = z.object({
  elementType: z.nativeEnum(WidgetElementType),
  selector: z
    .string()
    .min(1)
    .max(4096)
    .refine((selector) => selector.trim().length > 0),
  insertionPosition: z.nativeEnum(InsertionPosition),
  shadowRootSelector: z
    .string()
    .min(1)
    .max(4096)
    .refine((selector) => selector.trim().length > 0)
    .optional(),
});
export type CoveragePlacement = z.infer<typeof coveragePlacementSchema>;

export const coverageLoadedEventSchema = z.object({
  themeId: z.string().regex(/^\d+$/).max(32),
  treatmentId: z
    .string()
    .regex(/^[a-f\d]{24}$/i)
    .nullable(),
  url: z.string().url().max(8192),
  path: z.string().max(2048),
  pageType: z.enum([
    "pdp",
    "collection",
    "cart",
    "homepage",
    "information-page",
    "unknown",
  ]),
});
export type CoverageLoadedEvent = z.infer<typeof coverageLoadedEventSchema>;

export const coveragePlacementEventSchema = coverageLoadedEventSchema.extend({
  placements: z.array(coveragePlacementSchema).min(1).max(50),
});
export type CoveragePlacementEvent = z.infer<
  typeof coveragePlacementEventSchema
>;

export type CoveragePlacementMetrics = Record<
  string,
  Record<
    string,
    {
      lastLoadedAt?: string;
      placements: Record<string, CoveragePlacement & { lastSeenAt: string }>;
    }
  >
>;

export function coverageTreatmentKey(treatmentId: string | null): string {
  return treatmentId ?? "default";
}

export function coveragePlacementId(placement: CoveragePlacement): string {
  return JSON.stringify([
    placement.elementType,
    placement.selector,
    placement.insertionPosition,
    placement.shadowRootSelector ?? null,
  ]);
}
